import { render } from "./ContactBanner.vue?vue&type=template&id=62d5e705&scoped=true"
import script from "./ContactBanner.vue?vue&type=script&lang=js"
export * from "./ContactBanner.vue?vue&type=script&lang=js"

import "./ContactBanner.vue?vue&type=style&index=0&id=62d5e705&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d5e705"]])

export default __exports__